/* eslint-disable no-new */
import Cookies from 'universal-cookie';

const cookies = new Cookies();

const COOKIE_OPTIONS = { path: '/', sameSite: 'Strict' };

const AUTH_COOKIE_KEYS = [
  'Token',
  'refreshToken',
  'USERID',
  'USERNAME',
  'USERROLE',
  'PROFILE',
  'USERPERMISSION',
  'UNREADNOTIFICATIONCOUNT',
];

export const getCookies = (value = '') => cookies.get(value);

export const removeCookies = (value = '') => {
  cookies.remove(value, COOKIE_OPTIONS);
  return Promise.resolve();
};

export const clearAuthSession = () => {
  AUTH_COOKIE_KEYS.forEach((key) => {
    cookies.remove(key, COOKIE_OPTIONS);
  });
};

export const setCookies = (key = '', value = '') => {
  cookies.set(key, value, COOKIE_OPTIONS);
};
